// extracted by mini-css-extract-plugin
module.exports = {"hidden":"Embaixador_hidden__Anvud","loading":"Embaixador_loading__1WIt2","content":"Embaixador_content__x4HSL","section_button":"Embaixador_section_button__3NofZ"};